var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconMobile64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3332 8.50293H22.6665C20.4574 8.50293 18.6665 10.2938 18.6665 12.5029V52.5029C18.6665 54.7121 20.4574 56.5029 22.6665 56.5029H41.3332C43.5423 56.5029 45.3332 54.7121 45.3332 52.5029V12.5029C45.3332 10.2938 43.5423 8.50293 41.3332 8.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3332 8.50293H22.6665C20.4574 8.50293 18.6665 10.2938 18.6665 12.5029V52.5029C18.6665 54.7121 20.4574 56.5029 22.6665 56.5029H41.3332C43.5423 56.5029 45.3332 54.7121 45.3332 52.5029V12.5029C45.3332 10.2938 43.5423 8.50293 41.3332 8.50293Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6665 49.6455H45.3332V52.5026C45.3332 54.7118 43.5423 56.5026 41.3332 56.5026H22.6665C20.4574 56.5026 18.6665 54.7118 18.6665 52.5026V49.6455Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 54.7889C32.9604 54.7889 33.739 54.0214 33.739 53.0746C33.739 52.1279 32.9604 51.3604 31.9999 51.3604C31.0394 51.3604 30.2607 52.1279 30.2607 53.0746C30.2607 54.0214 31.0394 54.7889 31.9999 54.7889Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5215 11.9312H36.6374",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconMobile64);
export default __webpack_public_path__ + "static/media/pictogramBeaconMobile64.0f3f1486c7412b1129e968f72ad1028b.svg";
export { ForwardRef as ReactComponent };